export default __webpack_public_path__ + "static/media/dubbed-slider.60a11dda.svg";